// ========================================================================
// 📁 shared/ImageSlider.js
// Purpose: A dedicated, clean component for the image carousel.
// ========================================================================

import {useState} from "react";
import {ChevronRight, ChevronLeft} from "lucide-react";
import LightboxImage from "../Popup/LightboxImage";
import {NoDataMessage} from "./ApprovalActions";

const ImageSlider = ({ images, altText, jobId }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    if (!images || images.length === 0) {
        return <NoDataMessage message="No images available" />;
    }

    const goToSlide = (index) => {
        const newIndex = (index + images.length) % images.length;
        setCurrentIndex(newIndex);
    };

    return (
        <div className="relative bg-black rounded-lg overflow-hidden shadow-lg aspect-video">
            <LightboxImage
                key={currentIndex}
                src={images[currentIndex]}
                group={`${altText}-${jobId}`}
                className="w-full h-full object-contain"
            />
            {images.length > 1 && (
                <>
                    <button onClick={() => goToSlide(currentIndex - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 p-2 bg-black/50 hover:bg-black/70 rounded-full text-white z-20">
                        <ChevronLeft className="w-5 h-5" />
                    </button>
                    <button onClick={() => goToSlide(currentIndex + 1)} className="absolute right-2 top-1/2 -translate-y-1/2 p-2 bg-black/50 hover:bg-black/70 rounded-full text-white z-20">
                        <ChevronRight className="w-5 h-5" />
                    </button>
                    <div className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-black/50 text-white px-3 py-1 rounded-full text-sm z-20">
                        {currentIndex + 1} / {images.length}
                    </div>
                </>
            )}
        </div>
    );
};

export default ImageSlider;
